import { connect } from 'react-redux';
import equal from 'fast-deep-equal';
import ReviewItem from './ReviewItem';
import { fetchBrands } from '../../actions/brands';
import { updateReview } from '../../actions/reviews';

function mapStateToProps({ brands, auth, reviews }, { review }) {
  const reviewFromState = reviews.byId[review.id];

  return {
    brands: brands.brandsById,
    isAnonUser: !auth.account_id,
    review: reviewFromState && !equal(review, reviewFromState) ? reviewFromState : review,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchBrands: brandIds => dispatch(fetchBrands(brandIds)),
    updateReview: body => dispatch(updateReview(body)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewItem);
